//@flow
import FunctionStore from '../Base/functionStoreClass';
import { apiUpdateState, applyServerDefaultData } from '../Base/storeUtils';
import Constants from '../../constants';
import Api from '../../APIInterfaces/categories';
import CategoriesCollection from './categoriesCollection';
import MarketingCategoriesCollection from './marketingCategoriesCollection';
import CorporateCategoriesCollection from './corporateCategoriesCollection';
import { toImmutable } from '../../Utils/immutable';
import testData from '../../Utils/testData';

import type { HandlerAdd, StoreState } from '../Base/functionStoreClass';
import type { CategoryObject } from './categoryModel';

// eslint-disable-next-line no-undef
const USE_TEST_DATA = process.env.USE_TEST_DATA === 'true';


export default class CategoriesStore extends FunctionStore {
  getCategories():CategoriesCollection {
    return this._resolvePropertyObject('categories', CategoriesCollection, Api.getCategories);
  }

  getMarketingCategories():MarketingCategoriesCollection {
    return this._resolvePropertyObject('categories', MarketingCategoriesCollection, Api.getCategories);
  }

  getCorporateCategories():CorporateCategoriesCollection {
    return this._resolvePropertyObject('categories', CorporateCategoriesCollection, Api.getCategories);
  }

  _initialState(state:StoreState) {
    applyServerDefaultData('categoriesData', state, _responseToGetCategoriesSuccess);
    if (USE_TEST_DATA) {
      _setCategories(state, testData.categories);
    }
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.GET_CATEGORIES_SUCCESS, apiUpdateState(_responseToGetCategoriesSuccess));
  }
}

function _responseToGetCategoriesSuccess(data:StoreState, resp:Object) {
  data.set('categories', toImmutable(resp));
}

function _setCategories(data:StoreState, resp:{[string]:CategoryObject}) {
  data.set('categories', toImmutable(resp));
}
